import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import bindMethods from 'auto-bind';
import ReactTable from 'react-table';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const OrgsTableContainer = styled.table`
  border-collapse: collapse;
  width: 100%;

  td,
  th {
    text-align: left;
    padding: 14px 0px;
  }

  th {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    color: ${props => props.theme.BLACK};
  }

  tbody {
    tr {
      cursor: pointer;
    }

    tr:nth-child(odd) {
      background-color: ${props => props.theme.NEUTRAL_GREY};
    }
  }
`;

const StyledNameCell = styled.td`
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  color: ${props => props.theme.BLACK};
`;

const StyledStatusCell = styled.td`
  display: flex;
  justify-content: start;
`;

const StyledStatusPill = styled.div`
  width: 85px;
  height: 20px;
  border-radius: 30px;
  background-color: ${props => (props.status ? props.theme.SAFE : props.theme.WARNING)};
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 12px;
    font-weight: bold;
    color: ${props => props.theme.WHITE};
  }
`;

const SearchInputField = styled.input`
  width: 385px;
  height: 36px;
  border-radius: 1px;
  border: ${props => `solid 1px ${props.theme.GREY}`};
  padding: 8px 11px;
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 10px;
`;

class OrgsTable extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);

    this.state = {
      orgs: props.orgs,
    };

    this.TABLE_COLUMNS = [
      {
        Header: 'Name',
        accessor: 'displayName',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
    ];
  }

  handleSearch(event) {
    const { value } = event.target;
    const { orgs: propOrgs } = this.props;

    this.setState({
      orgs: propOrgs.filter((org) => {
        const orgName = org.displayName.toLowerCase();
        return orgName.includes(value.toLowerCase());
      }),
    });
  }

  handleTableRowClick(row) {
    const { history } = this.props;
    const { id } = row;

    history.push(`/orgs/${id}`);
  }

  renderNameCell(row, index) {
    return (
      <StyledNameCell
        id={`OrgTableRow.displayName.${index}`}
        key={`OrgTableRow.displayName.${row.id}`}
      >
        {row.displayName}
      </StyledNameCell>
    );
  }

  renderStatusCell(row, index) {
    const { t } = this.props;

    const term = row.status ? t('Shared.General.Active') : t('Shared.General.Inactive');
    return (
      <StyledStatusCell key={`OrgTableRow.status.${row.id}`} id={`OrgTableRow.status.${index}`}>
        <StyledStatusPill status={row.status}>
          <span>{term}</span>
        </StyledStatusPill>
      </StyledStatusCell>
    );
  }

  renderTableRow(row, columns, index) {
    return (
      <tr
        id={`OrgTableRow.${index}`}
        key={`OrgTableRow.${row.id}`}
        onClick={this.handleTableRowClick.bind(null, row)}
      >
        {columns.map((column) => {
          switch (column.accessor) {
            case 'displayName':
              return this.renderNameCell(row, index);
            case 'status':
              return this.renderStatusCell(row, index);
            default:
              return null;
          }
        })}
      </tr>
    );
  }

  // eslint-disable-next-line no-unused-vars
  renderOrgsTable(state, makeTable, instance) {
    const { t } = this.props;
    const { columns, data } = state;

    return (
      <>
        <SearchInputField
          id="Pages.Orgs.SearchOrg"
          placeholder={t('Pages.Orgs.Actions.SearchOrg')}
          onChange={this.handleSearch}
        />
        <OrgsTableContainer id="OrgsTable">
          <thead>
            <tr>
              {columns.map(column => (
                <th key={`OrgsTable.${column.Header}`} id={`OrgsTable.Header.${column.Header}`}>
                  {column.Header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{data.map((row, index) => this.renderTableRow(row, columns, index))}</tbody>
        </OrgsTableContainer>
      </>
    );
  }

  render() {
    const { orgs } = this.state;

    return (
      <ReactTable columns={this.TABLE_COLUMNS} data={orgs}>
        {this.renderOrgsTable}
      </ReactTable>
    );
  }
}

OrgsTable.propTypes = {
  history: PropTypes.object.isRequired, // supplied from withRouter
  t: PropTypes.func.isRequired, // supplied from withTranslation
  orgs: PropTypes.array.isRequired,
};

const TranslatedComponent = withTranslation()(OrgsTable);
export default withRouter(TranslatedComponent);
